import { assessments } from "./assessments";
import { attendance } from "./attendance";
import { availability } from "./availability";
import { exclusionDates } from "./exclusion-dates";
import { groups } from "./groups";
import { members } from "./members";
import { seasons } from "./seasons";
import { sessions } from "./sessions";
import { slots } from "./slots";

export const training = {
	assessments,
	attendance,
	availability,
	exclusionDates,
	groups,
	members,
	seasons,
	sessions,
	slots,
};
